import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./styles/tailwind.css";
import "./locale";

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
